import { DetailedHTMLProps, FC, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { FloatingElementReturn } from '../helpers/floating.types';
import FloatingArrow from './FloatingArrow';

interface FloatingElementProps
    extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
        Pick<FloatingElementReturn, 'context' | 'refs'> {}

const FloatingElement: FC<FloatingElementProps> = (props) => {
    const { children, context, refs, className, style, ...rest } = props;

    return (
        <>
            {context.open && (
                <div
                    {...rest}
                    ref={refs.setFloating}
                    className={twMerge('bg-floating-color fill-floating-color rounded-lg outline-none', className)}
                    style={{ ...style, ...context.floatingStyles }}
                >
                    {children}

                    {context.middlewareData.arrow && (
                        <FloatingArrow context={context} ref={refs.arrow} className="fill-[inherit]" />
                    )}
                </div>
            )}
        </>
    );
};

export default FloatingElement;
